export default __webpack_public_path__ + "static/media/addprofile.7224f56d.svg";